export default {
    inserted(el) {
      // 初始隐藏元素
      el.style.opacity = 0;
  
      let isAnimating = false; // 标记是否正在执行动画
  
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isAnimating) {
              // 显示元素并触发动画
              el.style.opacity = 1;
              el.classList.add('animate__animated', 'animate__slideInUp');
  
              // 标记为正在执行动画
              isAnimating = true;
  
              // 监听动画结束事件
              el.addEventListener('animationend', () => {
                // 动画结束后移除动画类
                el.classList.remove('animate__animated', 'animate__slideInUp');
                isAnimating = false; // 重置标记
              }, { once: true }); // 只监听一次
            }
          });
        },
        {
          threshold: 0, // 当元素 20% 进入视口时触发
          rootMargin: '20px', // 视口边界扩展（可根据需要调整）
        }
      );
  
      // 开始观察目标元素
      observer.observe(el);
    },
  };